import { render, staticRenderFns } from "./TableNoData.vue?vue&type=template&id=972cdb60&scoped=true&"
import script from "./TableNoData.vue?vue&type=script&lang=js&"
export * from "./TableNoData.vue?vue&type=script&lang=js&"
import style0 from "./TableNoData.vue?vue&type=style&index=0&id=972cdb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972cdb60",
  null
  
)

export default component.exports